export type LubricationOption = {
  value: string;
  labelKey: string;
};

export const lubricationTypes: LubricationOption[] = [
  { labelKey: 'traceability.lubricationTab.options.dry', value: 'sec' },
  { labelKey: 'traceability.lubricationTab.options.oil', value: 'huile' },
  { labelKey: 'traceability.lubricationTab.options.emulsion', value: 'emulsion' },
  { labelKey: 'traceability.lubricationTab.options.mql', value: 'microlub' },
  { labelKey: 'traceability.lubricationTab.options.co2', value: 'co2' },
  { labelKey: 'traceability.lubricationTab.options.air', value: 'air' },
  { labelKey: 'traceability.lubricationTab.options.other', value: 'other' },
];
